import { Action } from '@ngrx/store';
import { ListItem } from '../../core/models/list-item';
import { CoordinateList } from '../models/coordinate-list';

export const LOAD_ALL_SITES = '[Sites] Load All Sites';
export const LOAD_ALL_SITES_COMPLETE = '[Sites] Load Complete';
export const LOAD_ALL_FARMS = '[Sites] Load All Farms';
export const LOAD_ALL_FARMS_COMPLETE = '[Sites] Load All Farms Complete';
export const SELECT_SITE = '[Sites] Select';
export const SELECT_SITE_BY_ID = '[Sites] Select By Id';
export const UPDATE_SITE = '[Sites] Update';
export const UPDATE_SITE_COMPLETE = '[Sites] Update Complete';
export const LOAD_AUTHORS = '[Sites] Load Authors';
export const LOAD_AUTHORS_COMPLETE = '[Sites] Load Authors Complete';
export const LOAD_FARM_GPS = '[Sites] Load Farm GPS';
export const LOAD_FARM_GPS_COMPLETE = '[Sites] Load Farm GPS Complete';
export const LOAD_AOC_GPS = '[Sites] Load AOC GPS';
export const LOAD_AOC_GPS_COMPLETE = '[Sites] Load AOC GPS Complete';

export class LoadAllSitesAction implements Action {
  readonly type = LOAD_ALL_SITES;
}

export class LoadAllSitesCompleteAction implements Action {
  readonly type = LOAD_ALL_SITES_COMPLETE;

  constructor(public payload: ListItem[]) {}
}

export class LoadAllFarmsAction implements Action {
  readonly type = LOAD_ALL_FARMS;
}

export class LoadAllFarmsCompleteAction implements Action {
  readonly type = LOAD_ALL_FARMS_COMPLETE;

  constructor(public payload: ListItem[]) {}
}

export class SelectSiteAction implements Action {
  readonly type = SELECT_SITE;

  constructor(public payload: string) {}
}

export class SelectSiteByIdAction implements Action {
  readonly type = SELECT_SITE_BY_ID;

  constructor(public payload: number) {}
}

export class UpdateSiteAction implements Action {
  readonly type = UPDATE_SITE;
  constructor(public payload: ListItem) {}
}

export class UpdateSiteCompleteAction implements Action {
  readonly type = UPDATE_SITE_COMPLETE;

  constructor(public payload: ListItem) {}
}

export class LoadFarmGpsAction implements Action {
  readonly type = LOAD_FARM_GPS;
}

export class LoadFarmGpsCompleteAction implements Action {
  readonly type = LOAD_FARM_GPS_COMPLETE;

  constructor(public payload: CoordinateList[]) {}
}

export class LoadAocGpsAction implements Action {
  readonly type = LOAD_AOC_GPS;
}

export class LoadAocGpsCompleteAction implements Action {
  readonly type = LOAD_AOC_GPS_COMPLETE;

  constructor(public payload: CoordinateList[]) { }
}

export class LoadAuthorsAction implements Action {
  readonly type = LOAD_AUTHORS;
}

export class LoadAuthorsCompleteAction implements Action {
  readonly type = LOAD_AUTHORS_COMPLETE;

  constructor(public payload: string[]) { }
}

export type Actions = LoadAllSitesAction | LoadAllSitesCompleteAction |
  LoadAllFarmsAction | LoadAllFarmsCompleteAction | SelectSiteAction |
  UpdateSiteAction | UpdateSiteCompleteAction | SelectSiteByIdAction |
  LoadAuthorsAction | LoadAuthorsCompleteAction | LoadFarmGpsAction |
  LoadFarmGpsCompleteAction | LoadAocGpsAction | LoadAocGpsCompleteAction;



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/actions/site.ts